import React, { Component } from 'react';
import './basicforms.css';

class SignUpEmailConfirm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      code: ''
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleResend = this.handleResend.bind(this);
  }

  handleChange(event) {
    this.setState({[event.target.name]: event.target.value});
  }

  handleSubmit(event) {
    //this.props.handleVerify(code);
    this.props.auth.confirmSignUp(this.props.username, this.state.code, {
    // Optional. Force user confirmation irrespective of existing alias. By default set to True.
    forceAliasCreation: true
    }).then(data => {
      console.log(data);
      this.props.history.push('/signin');
    })
    .catch(error => {
      console.log(error);
      alert(error.message || JSON.stringify(error));
    });

    event.preventDefault();
  }

  handleResend() {
    this.props.auth.resendSignUp(this.props.username).then(() => {
      console.log('code resent successfully');
      alert('Code resent successfully to ' + this.props.username + '!');
    }).catch(e => {
      console.log(e);
    });
  }

  render() {

    return (

      <div>
        <h3>Please, enter code sent to {this.props.username}</h3>
        <form className='basicforms' onSubmit={this.handleSubmit}>
    			<div className='form_container' >
    				<p className='pagetitle'>{this.props.name}</p>
    				<div className="row">
    					<div className="col-25">
    						<label>Please, enter the confirmation code that was sent by e-mail:</label>
    					</div>
    					<div className="col-50">
    						<input type="number" name="code" value={this.state.code} onChange={this.handleChange} />
    					</div>
    				</div>
    				<div className="row">
    				<div className="col-75">
    					<input type="submit" value="Submit"/>
    				</div>
    		    	</div>

              <div className="row">
                <div className="col-75">
                  <input type="button" value="Resend Code by Email" onClick={this.handleResend}/>
                </div>
              </div>

    			</div>
    		  </form>
        </div>
    );
  }
}

export default SignUpEmailConfirm;



// WEBPACK FOOTER //
// ./src/components/SignUpEmailConfirm.js